export function axIsTypeNumber(x) {
    return typeof x === 'number';
}
